module.exports = __webpack_public_path__ + "media/common/images/review_1-5a70817292182a6b82df8a25beac3894.png";